import { Component } from '../../scripts/component';

class ReleaseStickyCta extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.placeholder = this.previousElementSibling;
    if (!this.placeholder) return;

    this.ticking = false;
    this.buttonHeight = this.offsetHeight;

    this.scrollHandler = () => {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    };

    this.resizeHandler = () => {
      this.isMobile = window.innerWidth <= 991;
      if (!this.isMobile) {
        this.classList.remove('is-fixed');
        this.placeholder.style.height = '0';
      }
    };

    this.isMobile = window.innerWidth <= 991;
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    window.addEventListener('resize', this.resizeHandler, { passive: true });
    this.handleScroll();
  }

  handleScroll() {
    if (!this.isMobile) return;

    const rect = this.placeholder.getBoundingClientRect();

    if (rect.top < -20) {
      if (!this.classList.contains('is-fixed')) {
        this.placeholder.style.height = this.buttonHeight + 'px';
        this.classList.add('is-fixed');
      }
    } else if (rect.top >= 0) {
      this.classList.remove('is-fixed');
      this.placeholder.style.height = '0';
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);
    super.disconnectedCallback();
  }
}

if (!customElements.get('release-sticky-cta')) {
  customElements.define('release-sticky-cta', ReleaseStickyCta);
}
